/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Summerinocchumiditysetpoint3Inputs */



/**
* | output |
* | --- |
* | "Summer unoccupied humidity setpoint" |
*
* @param {Ahu_History_Key_Summerinocchumiditysetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_summerinocchumiditysetpoint3 = /** @type {((inputs?: Ahu_History_Key_Summerinocchumiditysetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Summerinocchumiditysetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer unoccupied humidity setpoint")
	return /** @type {LocalizedString} */ ("Consigne d'hygrométrie inoccupation été")
});
export { ahu_history_key_summerinocchumiditysetpoint3 as "ahu_history_key_summerInoccHumiditySetpoint" }